import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";
import { jwtDecode } from "jwt-decode";

export const admin_login = createAsyncThunk(
    'auth/admin_login',
    async(info,{rejectWithValue, fulfillWithValue}) => {
        try {
            const {data} = await api.post('/admin-login',info,{withCredentials: true})
            // Token stocké dans cookie httpOnly par le backend
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const seller_login = createAsyncThunk(
    'auth/seller_login',
    async(info,{rejectWithValue, fulfillWithValue}) => {
        try {
            const {data} = await api.post('/seller-login',info,{withCredentials: true})
            // Token stocké dans cookie httpOnly par le backend
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const get_user_info = createAsyncThunk(
    'auth/get_user_info',
    async(_ ,{rejectWithValue, fulfillWithValue}) => {
          
        try {
            const {data} = await api.get('/get-user',{withCredentials: true})
            // console.log(data)            
            return fulfillWithValue(data)
        } catch (error) {
            // console.log(error.response.data)
            return rejectWithValue(error.response.data)
        }
    }
)


export const profile_image_upload = createAsyncThunk(
    'auth/profile_image_upload',
    async(image ,{rejectWithValue, fulfillWithValue}) => {
          
        try {
            const {data} = await api.post('/profile-image-upload',image,{withCredentials: true})
            // console.log(data)            
            return fulfillWithValue(data)
        } catch (error) {
            // console.log(error.response.data)
            return rejectWithValue(error.response.data)
        }
    }
)
// end method 

export const seller_register = createAsyncThunk(
    'auth/seller_register',
    async(info,{rejectWithValue, fulfillWithValue}) => { 
        try {
            const {data} = await api.post('/seller-register',info,{withCredentials: true})
            // Token stocké dans cookie httpOnly par le backend
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

// end method 

export const profile_info_add = createAsyncThunk(
    'auth/profile_info_add',
    async(info,{rejectWithValue, fulfillWithValue}) => { 
        try { 
            const {data} = await api.post('/profile-info-add',info,{withCredentials: true}) 
            return fulfillWithValue(data)
        } catch (error) {
            // console.log(error.response.data)
            return rejectWithValue(error.response.data)
        }
    }
)
// end method 



    const returnRole = (token) => {
        if (token) {
           const decodeToken = jwtDecode(token)
           const expireTime = new Date(decodeToken.exp * 1000)
           if (new Date() > expireTime) {
             return ''
           } else {
                return decodeToken.role
           }
            
        } else {
            return ''
        }
    }

    // end Method 

    export const logout = createAsyncThunk(
        'auth/logout',
        async({navigate,role},{rejectWithValue, fulfillWithValue}) => {
             
            try {
                const {data} = await api.get('/logout', {withCredentials: true})
                // Cookie supprimé par le backend
                if (role === 'admin') {
                    navigate('/admin/login')
                } else {
                    navigate('/login')
                }
                return fulfillWithValue(data)
            } catch (error) {
                return rejectWithValue(error.response.data)
            }
        }
    )

        // end Method 

    /// Chanage Password method

    export const change_password = createAsyncThunk(
        'auth/change_password',
        async(info ,{rejectWithValue, fulfillWithValue}) => {
              
            try {
                const {data} = await api.post('/change-password',info,{withCredentials: true})
                // console.log(data)            
                return fulfillWithValue(data.message)
            } catch (error) {
                // console.log(error.response.data)
                return rejectWithValue(error.response.data.message)
            }
        }
    )
    // end method

    export const seller_forgot_password = createAsyncThunk(
        'auth/seller_forgot_password',
        async(email, {rejectWithValue, fulfillWithValue}) => {
            try {
                const {data} = await api.post('/seller-forgot-password', { email }, {withCredentials: true})
                return fulfillWithValue(data)
            } catch (error) {
                return rejectWithValue(error.response.data)
            }
        }
    )
    // end method

    export const seller_reset_password = createAsyncThunk(
        'auth/seller_reset_password',
        async(info, {rejectWithValue, fulfillWithValue}) => {
            try {
                const {data} = await api.post('/seller-reset-password', info, {withCredentials: true})
                return fulfillWithValue(data)
            } catch (error) {
                return rejectWithValue(error.response.data)
            }
        }
    )
    // end method 

    export const update_user_info = createAsyncThunk(
        'auth/update_user_info',
        async(info, {rejectWithValue, fulfillWithValue}) => {
            try {
                const {data} = await api.post('/update-user-info', info, {withCredentials: true})
                return fulfillWithValue(data)
            } catch (error) {
                return rejectWithValue(error.response.data)
            }
        }
    )
    // end method 

 
export const authReducer = createSlice({
    name: 'auth',
    initialState:{
        successMessage :  '',
        errorMessage : '',
        loader: false,
        userInfo : '',
        role: '',
        token: null,
        authChecked: false
    },
    reducers : {

        messageClear : (state,_) => {
            state.errorMessage = ""
            state.successMessage = ""
        },
        
        resetAuth : (state) => {
            state.userInfo = ''
            state.role = ''
            state.token = null
            state.authChecked = false
        }

    },
    extraReducers: (builder) => {
        builder
        .addCase(admin_login.pending, (state, { payload }) => {
            state.loader = true;
        })
        .addCase(admin_login.rejected, (state, { payload }) => {
            state.loader = false;
            state.errorMessage = payload?.error || payload?.message || 'Erreur de connexion'
        }) 
        .addCase(admin_login.fulfilled, (state, { payload }) => {
            state.loader = false;
            state.successMessage = payload.message
            state.token = payload.token
            state.role = returnRole(payload.token)
        })

        .addCase(seller_login.pending, (state, { payload }) => {
            state.loader = true;
        }) 
        .addCase(seller_login.rejected, (state, { payload }) => {
            state.loader = false;
            state.errorMessage = payload?.error || payload?.message || 'Erreur de connexion'
        }) 
        .addCase(seller_login.fulfilled, (state, { payload }) => {
            state.loader = false;
            state.successMessage = payload.message
            state.token = payload.token
            state.role = returnRole(payload.token)
        })

        .addCase(seller_register.pending, (state, { payload }) => {
            state.loader = true;
        })
        .addCase(seller_register.rejected, (state, { payload }) => {
            state.loader = false;
            state.errorMessage = payload?.error || payload?.message || 'Erreur d\'inscription'
        }) 
        .addCase(seller_register.fulfilled, (state, { payload }) => {
            state.loader = false;
            state.successMessage = payload.message
            state.token = payload.token
            state.role = returnRole(payload.token)
        })

        .addCase(get_user_info.fulfilled, (state, { payload }) => {
            state.loader = false;
            state.userInfo = payload.userInfo
            state.role = payload.userInfo.role
            state.authChecked = true
        })
        .addCase(get_user_info.rejected, (state) => {
            state.loader = false;
            state.userInfo = ''
            state.role = ''
            state.token = null
            state.authChecked = true
        })

        .addCase(profile_image_upload.pending, (state, { payload }) => {
            state.loader = true; 
        })
        .addCase(profile_image_upload.fulfilled, (state, { payload }) => {
            state.loader = false;
            state.userInfo = payload.userInfo
            state.successMessage = payload.message
        })

        .addCase(profile_info_add.pending, (state, { payload }) => {
            state.loader = true; 
        })
        .addCase(profile_info_add.fulfilled, (state, { payload }) => {
            state.loader = false;
            state.userInfo = payload.userInfo
            state.successMessage = payload.message
        })

        /// change Password
        .addCase(change_password.pending, (state) => {
            state.loader = true;
            state.errorMessage = null;
        })
        .addCase(change_password.rejected, (state,action) => {
            state.loader = false;
            state.errorMessage = action.payload;
        }) 
        .addCase(change_password.fulfilled, (state,action) => {
            state.loader = false;
            state.successMessage = action.payload 
        })

        /// forgot password
        .addCase(seller_forgot_password.pending, (state) => {
            state.loader = true;
        })
        .addCase(seller_forgot_password.rejected, (state, { payload }) => {
            state.loader = false;
            state.errorMessage = payload?.error || payload?.message || 'Erreur lors de l\'envoi';
        })
        .addCase(seller_forgot_password.fulfilled, (state, { payload }) => {
            state.loader = false;
            state.successMessage = payload.message;
        })

        /// reset password
        .addCase(seller_reset_password.pending, (state) => {
            state.loader = true;
        })
        .addCase(seller_reset_password.rejected, (state, { payload }) => {
            state.loader = false;
            state.errorMessage = payload?.error || payload?.message || 'Erreur lors de la réinitialisation';
        })
        .addCase(seller_reset_password.fulfilled, (state, { payload }) => {
            state.loader = false;
            state.successMessage = payload.message;
        })

        /// update user info
        .addCase(update_user_info.pending, (state) => {
            state.loader = true;
        })
        .addCase(update_user_info.rejected, (state, { payload }) => {
            state.loader = false;
            state.errorMessage = payload?.error || payload?.message || 'Erreur lors de la mise à jour';
        })
        .addCase(update_user_info.fulfilled, (state, { payload }) => {
            state.loader = false;
            state.successMessage = payload.message;
            state.userInfo = payload.userInfo;
        });


    }

})
export const {messageClear, resetAuth} = authReducer.actions
export default authReducer.reducer